import { MediaEntity } from '@/pages/AdvancedEditor/components/panels/media/types';
import { RowsPhotoAlbum } from 'react-photo-album';
import 'react-photo-album/rows.css';
import { MediaTile } from './MediaTile';

interface Props {
    media: MediaEntity[];
    onDelete: (id: string) => Promise<void>;
}

export const MediaGrid = ({ media, onDelete }: Props) => {
    const photos = media.map(item => ({
        src: '',
        filename: '',
        ...item,
    }));

    return (
        <RowsPhotoAlbum
            componentsProps={{ container: { style: { overflowY: 'auto', scrollbarGutter: 'stable' } } }}
            photos={photos}
            targetRowHeight={144}
            spacing={8}
            render={{
                photo: (_, { photo, width, height }) => (
                    <MediaTile key={photo.id} entity={{ ...photo }} width={width} height={height} onDelete={onDelete} />
                ),
            }}
        />
    );
};
